module.exports = __webpack_public_path__ + "static/img/right_jiao_icon.8e4795b7.png";